import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6aa49e24&scoped=true&lang=pug&"
import script from "./Header.js?vue&type=script&lang=js&"
export * from "./Header.js?vue&type=script&lang=js&"
import style0 from "./Header.sass?vue&type=style&index=0&id=6aa49e24&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa49e24",
  null
  
)

export default component.exports